import {Store} from '@ngrx/store';
import {AppState} from '../appstate';
import {distinctUntilChanged, filter, map, Observable} from 'rxjs';
import {ScorerState} from './';
import {CompetitionInfo} from '../../data/competition-data';
import {Injectable} from '@angular/core';
/**
 * Created by ashok on 15/05/17.
 */
@Injectable()
export class ScorerStateDataService {
    constructor(private store: Store<AppState>){}

    scorerState(): Observable<ScorerState> {
        return this.store.select((appState:any)=>appState.reducers.scorerState)
            .pipe(filter(Boolean));
    }
    activeCompetitions(): Observable<CompetitionInfo[]> {
        return this.store.select((appState:any)=>appState.reducers.scorerState.competitions)
            .pipe(filter(Boolean));
    }

    currentError() : Observable<any> {
        return this.store.select((appState:any)=>appState.reducers.scorerState)
            .pipe(map(scorerState=>{
                if(scorerState.error)
                    return {
                        error: scorerState.error,
                        exception: scorerState.exception
                    }
                    else return null;
            })).pipe(filter(Boolean));
    }

    getTeetimeBooking(): Observable<any> {
        return this.store.select((appState:any)=>{
            // if(appState.reducers.teetimeBooking) return appState.reducers.teetimeBooking.clubId
          
            return appState.reducers.scorerState.teeBooking
        })
                .pipe(distinctUntilChanged())
                .pipe(filter(Boolean));
    }


}